import React from 'react';

import { easasAlert } from 'components/fragments/easas-global-fragment/EasasGlobalAlerts';
import { MdmDeviceDto, useGetDeviceQuery, useUpdateDeviceMutation, useUpdateDeviceRelationMutation } from 'gql/generated/types';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useNavigate, useParams } from 'react-router-dom';
import DeviceForm from '../components/DeviceForm';
import ErrorPage from './ErrorPage';

const EditDeviceForm = () => {
  const { projectId, deviceId } = useParams();
  const navigate = useNavigate()
  const { data, error, loading } = useGetDeviceQuery({ variables: { id: deviceId! } });
  const [updateDeviceMutation, { loading: updateLoading }] = useUpdateDeviceMutation({
    onCompleted: () => {
      easasAlert({
        severity: "success",
        summary: "Success",
        detail: "Device updated successfully",
        life: 3000,
      });
      navigate(`/mdm/${projectId}/devices`);
    },
    onError: err => {
      easasAlert({ severity: "error", summary: "Error", detail: err.message, life: 3000 });
    },
  });

  const [updateDeviceRelation] = useUpdateDeviceRelationMutation()
  
  if (error) {
    return <ErrorPage msg={`Device not found by id: ${deviceId}`} />;
  }

  if (loading) return <ProgressSpinner className='mt-3 w-full' />

  const handleUpdate = (device: Partial<MdmDeviceDto>) => {
    const { project, objectRelation, boundDatasets, status, createdAt, modifiedAt, ...restDevice } = device
    updateDeviceMutation({
      variables: { device: { ...restDevice }, objectId: objectRelation?.mdmObject?.id! },
    });
    updateDeviceRelation({
      variables: { input: { ...objectRelation, mdmDevice: { id: device.id } }! },
    });
  };

  return (
    <DeviceForm
      device={data?.mdmDeviceById as MdmDeviceDto}
      onSubmit={handleUpdate}
      loading={updateLoading}
    />
  );
}

export default EditDeviceForm